import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface CreateUserPayload {
  username: string;
  password: string;
  balance?: number;
  subDealerId: number;
  image?: string;
}

export async function createUser(
  payload: CreateUserPayload
): Promise<NewUser> {
  const res = await api.client.post("/users-new", payload);
  return res.data;
}
